import React, { useEffect, useState } from 'react';
import { getAllCourses } from '../services/courseService';
import { getAllCategories } from '../services/categoryService';
import './Hero.css';

function Hero() {
  const [heroStats, setHeroStats] = useState([
    { number: '0+', label: 'Active Courses' },
    { number: '0+', label: 'Course Categories' },
    { number: '24/7', label: 'Learning Support' }
  ]);

  useEffect(() => {
    const fetchHeroStats = async () => {
      try {
        const [coursesResponse, categoriesResponse] = await Promise.all([
          getAllCourses({ isActive: true }),
          getAllCategories({ isActive: true })
        ]);

        const coursesCount = coursesResponse?.success ? coursesResponse.data.length : 0;
        const categoriesCount = categoriesResponse?.success ? categoriesResponse.data.length : 0;

        setHeroStats([
          { number: `${coursesCount}+`, label: 'Active Courses' },
          { number: `${categoriesCount}+`, label: 'Course Categories' },
          { number: '24/7', label: 'Learning Support' }
        ]);
      } catch (error) {
        console.error('Error fetching hero stats:', error);
      }
    };

    fetchHeroStats();
  }, []);

  return (
    <section className="hero">
      <div className="container">
        <h1 className="hero-title">
          Smart Learning,<br />
          Better Futures
        </h1>
        
        <div className="stats">
          {heroStats.map((stat) => (
            <div className="stat-item" key={stat.label}>
              <h2 className="stat-number">{stat.number}</h2>
              <p className="stat-label">{stat.label}</p>
            </div>
          ))}
        </div>

        <div className="hero-devices">
          <div className="device-mockup laptop">
            <div className="device-screen">
              <div className="demo-content">
                <h3>Learning is everything</h3>
                <p>Make it Worth It Years at Durbhasi Gurukulam</p>
              </div>
            </div>
          </div>
          <div className="device-mockup mobile">
            <div className="device-screen"></div>
          </div>
          <div className="device-mockup desktop">
            <div className="device-screen"></div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
